module.exports = __webpack_public_path__ + "img/1984x940.8eafbf12.jpg";